var nordrheinWestfalenQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Nordrhein-Westfalen?',
    image: '391',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Nordrhein-Westfalen?',
    answers: [
      {
        content: 'Ammerland',
        key: 0,
      },
      {
        content: 'Rhein-Sieg-Kreis',
        key: 1,
      },
      {
        content: 'Nordfriesland',
        key: 0,
      },
      {
        content: 'Vogtlandkreis',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Nordrhein-Westfalen gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Nordrhein-Westfalen bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Nordrhein-Westfalen?',
    answers: [
      {
        content: 'rot-weiß',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 1,
      },
      {
        content: 'schwarz-gold',
        key: 0,
      },
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Nordrhein-Westfalen über politische Themen informieren?',
    answers: [
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Nordrhein-Westfalen heißt...',
    answers: [
      {
        content: 'Köln.',
        key: 0,
      },
      {
        content: 'Bonn.',
        key: 0,
      },
      {
        content: 'Düsseldorf.',
        key: 1,
      },
      {
        content: 'Dortmund.',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Nordrhein-Westfalen?',
    image: '398',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Nordrhein-Westfalen?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Nordrhein-Westfalen nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Nordrhein-Westfalen',
  },
]

export default nordrheinWestfalenQuestions
